const data = {
  program: [
    {
      image: 'khub_artikel_1.jpg',
      date: '25 Mar - 12 May',
      organization: 'AIPJ2',
      title: 'Lokakarya Komunikasi Strategis bagi Pemerintah dan OMS Aceh',
    },
    {
      image: 'khub_artikel_2.jpg',
      date: '8 Aug',
      organization: 'AIPJ2',
      title: 'Eu eiusmod eiusmod duis magna cupidatat consequat labore dolor do incididunt pariatur.',
    },
    {
      image: 'khub_artikel_3.jpg',
      date: '25 Mar - 12 May 2020',
      organization: 'Maarif Institute',
      title: 'Pariatur qui magna irure laboris ad velit laborum id veniam ad incididunt.',
    },
    {
      image: 'khub_artikel_2.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Ullamco ad sunt duis dolor ipsum sunt nostrud sint pariatur minim laborum elit.',
    },
    {
      image: 'khub_artikel_1.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_3.jpg',
      date: '8 Aug',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_1.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_2.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_3.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_1.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_artikel_1.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    }
  ],
  organization: [
    {
      name: 'Peace Generation Indonesia',
      image: 'khub_peacegen.svg',
      type: 'Non-Profit Organization',
      since: '2007',
      approach: 'Pencegahan',
      location: 'Bandung',
      issues: 'Pemuda, Pelajar'
    },
  ],
  event: [
    {
      image: 'khub_missing.jpg',
      date: '25 Mar - 12 May',
      organization: 'Peacegen Indonesia',
      title: 'MISSING: Konser 10 Tahun Kamisan dalam Pusaran Negeri',
    },
    {
      image: 'khub_missing.jpg',
      date: '8 Aug',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_missing.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_missing.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
  ],
  resources: [],
  blog: [
    {
      image: 'khub_blog_4.jpg',
      category: 'News',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: 'khub_blog_4.jpg',
      category: 'News',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    }
  ]
}

export default data